import { Createtask, UpdateTask } from '@/entities/tasks';
import { Api } from './api/axios-config';

export class TaskService{
  private static api = Api();
  
  public static async getTasks(businessId:number){
    const response = await this.api.get<any>(`tasks/${businessId}`);
    if(response.status === 200){
      return response.data;
    }
  }

  public static async updateTask(task:UpdateTask){
    const response = await this.api.post<any>('updateTask',{
      id: task.id,
      description: task.description,
      userId: task.userId,
      activityTypesId: task.activityTypesId,
      iniciatedAt: task.iniciatedAt,
      prevision: task.prevision,
      conclusionAt: task.conclusionAt,
      notification: task.notification,
      observation: task.observation,
      priority: task.priority,
      situation: task.situation,
      done: task.done,
    });
    if(response.status === 201){
      return response.data;
    }
  }

  public static async updateTaskDone(task:UpdateTask){
    const response = await this.api.post<any>('updateTaskDone',{
      id: task.id,
      description: task.description,
      userId: task.userId,
      activityTypesId: task.activityTypesId,
      iniciatedAt: task.iniciatedAt,
      prevision: task.prevision,
      conclusionAt: task.conclusionAt,
      notification: task.notification,
      observation: task.observation,
      priority: task.priority,
      situation: task.situation,
      done: task.done,
    });
    if(response.status === 201){
      return response.data;
    }
  }

  public static async createTask(task:Createtask){
    const response = await this.api.post('createTask',{
      description: task.description,
      userId: task.userId,
      activityTypesId: task.activityTypesId,
      businessId: task.businessId,
      iniciatedAt: task.iniciatedAt,
      prevision: task.prevision,
      done: task.done,
      conclusionAt: task.conclusionAt,
      notification: task.notification,
      observation: task.observation,
      priority: task.priority,
      situation: task.situation,
      userWhoAdds: task.userWhoAdds
    });
    if(response.status === 201){
      return response.data;
    }
  }

  public static async deleteTask(taskId:number){
    const response = await this.api.delete<any>(`deleteTask/${taskId}`);
    if(response.status){
      return response.data;
    }
  }
  
}
